'use client'

import React, { useRef } from 'react'
import { slugify } from '@/lib/sanitise-strings'

import AnchoredContentSidebar from '@/components/anchored-content/AnchoredContentSidebar'
import AnchoredContentBlocks from '@/components/anchored-content/AnchoredContentBlocks'

export type AnchoredContentSectionProps = {
  title: string
  anchorId?: string
  content: React.ReactNode
}

export type AnchoredContentProps = {
  sections: AnchoredContentSectionProps[]
}

export default function AnchoredContent({ sections }: AnchoredContentProps) {
  // Store references to this component and each section
  const componentRef = useRef(null)
  const sectionRefs = useRef([])

  // Bail if no links or components
  if (!sections?.length) {
    return null
  }

  // Loop through sections and generate anchor ID if not provided
  sections.forEach((section) => {
    section.anchorId = section.anchorId || slugify(section.title)
  })

  return (
    <>
      <div ref={componentRef} className="component component--anchored-content">
        <div className="container @container ms:px-0">
          <div className="@xl-up:border-r flex items-start justify-start gap-m border-gradient gradient-angle-[to_bottom] @l-up:border-l ms:flex-col ms:breakout">
            <div className="sticky z-30 flex-shrink-[1.5] duration-500 ease-in-out ms:top-[var(--header-height)] ms:min-w-full ms:bg-theme ms-up:top-[var(--sticky-offset)] ms-up:w-[419px]">
              <AnchoredContentSidebar
                sections={sections}
                componentRef={componentRef}
                sectionRefs={sectionRefs}
              />
            </div>

            <AnchoredContentBlocks sections={sections} sectionRefs={sectionRefs} />
          </div>
        </div>
      </div>
    </>
  )
}
